export const neusoftBlue = '#005BAC';
export const white = '#FFFFFF';
export const black = '#000000';
export const textColor = '#00002E';
export const bannerColor = '#F1F1F1';
export const secondTextColor = '#00002EA0';
export const secondBlue = '#00CCFF';
export const errorInputColor = '#DF7E54';
